// extracted by mini-css-extract-plugin
export default {"hubName":"hubName___YT16h","hubNoticeNumber":"hubNoticeNumber___E_T0o"};